import { useTranslation } from 'react-i18next'

interface AboutModalProps {
    onClose: () => void
}

/**
 * About Modal Component
 * Displays game description and info
 */
export function AboutModal({ onClose }: AboutModalProps) {
    const { t } = useTranslation()

    return (
        <div
            className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4"
            onClick={onClose}
        >
            <div
                className="bg-gray-900 rounded-2xl p-6 max-w-md w-full shadow-2xl border border-gray-700 relative"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Close button absolute top right */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-white transition-colors"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* Title */}
                <div className="text-center mb-6">
                    <h2 className="text-2xl font-bold text-white mb-2">
                        ℹ️ {t('home.about_title')}
                    </h2>
                </div>

                {/* Content */}
                <div className="text-gray-300 leading-relaxed whitespace-pre-wrap mb-6">
                    {t('home.about_desc')}
                </div>

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="w-full btn btn-primary flex items-center justify-center"
                >
                    {t('game.close')}
                </button>
            </div>
        </div>
    )
}
